import StudySessionProgressbar from "@memorang/ui/components/StudySession/StudySessionProgressbar/StudySessionProgressbar";
import { usePathname } from "expo-router";
import { memo } from "react";
import isEqual from "react-fast-compare";
import useCurrentSession from "../hooks/useCurrentSession";
import useSessionStore from "../hooks/useSessionStore";

type Props = {
	sessionType?: string;
};

const StudySessionProgressBar = ({ sessionType }: Props) => {
	const pathname = usePathname();
	const isReportPage = pathname.includes("report");
	const currentProgress = useSessionStore((state) => state.currentProgress);
	const isSummativeTest = useSessionStore((state) => state.isSummativeTest);
	const inReviewMode = useSessionStore((state) => state.inReviewMode);
	const blockStates = useSessionStore((state) => state.blockStates);

	const { currentBlockIndex, numSessionItems, currentBlock } =
		useCurrentSession();

	const blocks = [...blockStates.values()];

	return (
		<StudySessionProgressbar
			isSummativeTest={isSummativeTest}
			currentProgress={
				isReportPage && sessionType === "SUMMATIVE" ? 1 : currentProgress
			}
			isReportPage={isReportPage}
			inReviewMode={inReviewMode}
			blocks={blocks}
			currentBlockIndex={currentBlockIndex}
			numTotalBlocks={numSessionItems}
			numCurrentSessionItems={currentBlock.length}
		/>
	);
};

export default memo(StudySessionProgressBar, isEqual);
